import AuthLayout from '../layouts/auth/AuthLayout.vue'
import BaseLayout from '../layouts/base/BaseLayout.vue'
import Welcome from '../views/intranet/home/welcome/Welcome.vue'

import Login from "../views/auth/login/Login.vue";
import SignUp from "../views/auth/sign-up/SignUp.vue";

import ProductList from '../views/intranet/product/product-list/ProductList.vue'
import ProductForm from '../views/intranet/product/product-form/ProductForm.vue'
import ProductCategoryList from '../views/intranet/product/product-category-list/ProductCategoryList.vue'
import ProductCategoryForm from '../views/intranet/product/product-category-form/ProductCategoryForm.vue'
import ProductFeature from '../views/intranet/product/product-feature/ProductFeature.vue'
import ProductImage from '../views/intranet/product/product-image/ProductImage.vue'

export default [
   {
      path: '/login',
      component: AuthLayout,
      children: [
         {
            path: '',
            name: 'login',
            component: Login
         },
         {
            path: '/sign-up',
            name: 'signUp',
            component: SignUp
         }
      ]
   },
   {
      path: '',
      component: BaseLayout,
      meta: { requiresAuth: true },
      children: [
         {
            path: '',
            name: 'welcome',
            component: Welcome
         },
         {
            path: 'category',
            name: 'categories',
            component: ProductCategoryList
         },
         {
            path: 'category/new',
            name: 'newCategory',
            component: ProductCategoryForm
         },
         {
            path: 'category/edit/:categoryId',
            name: 'editCategory',
            component: ProductCategoryForm
         },
         {
            path: 'product',
            name: 'products',
            component: ProductList
         },
         {
            path: 'product/new',
            name: 'newProduct',
            component: ProductForm
         },
         {
            path: 'product/edit/:productId',
            name: 'editProduct',
            component: ProductForm
         },
         {
            path: 'product/:productId/feature',
            name: 'editFeatures',
            component: ProductFeature
         },
         {
            path: 'product/:productId/image',
            name: 'editImages',
            component: ProductImage
         },
      ]
   },
   {
      path: '*',
      redirect: '/login'
   }
]
